import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Skeleton } from '@/components/ui/FeedBack/Skeleton';
import { IconTextGroup } from '@/components/ui/Typography/IconText/IconTextGroup';
export const RfpClientStatusSkeleton = (props) => {
    const { className = '' } = props;
    return (_jsxs(IconTextGroup, Object.assign({ className: className, isInline: true, isVertical: true }, { children: [_jsx(Skeleton, { className: clsx('w-[24px] h-[24px]') }), _jsx(Skeleton, { className: clsx('w-[40px] h-[20px]') })] })));
};
